import { useContext } from "react";
import { AuthContext } from "../../../context/AuthContext";
import AdminDashboard from "./AdminDashboard";
import VendorDashboard from "./VendorDashboard";
import VendorManagerDashboard from "./VendorManagerDashboard";
import AccountManagerDashboard from "./AccountManagerDashboard";
import FeedbackWidget from "../../../components/Feedback/FeedbackWidget";

const roleDashboard = (roleSlug) => {
  if (roleSlug === "vendor") return <VendorDashboard />;
  if (roleSlug === "vendor_manager") return <VendorManagerDashboard />;
  if (roleSlug === "account_manager") return <AccountManagerDashboard />;
  return <AdminDashboard />;
};

const Dashboard = () => {
  const { user } = useContext(AuthContext);

  return (
    <>
      {roleDashboard(user?.roleSlug)}
      <FeedbackWidget />
    </>
  );
};

export default Dashboard;